import {ArtworkGuidelineType} from "../../definitions/enums";
import {isMobile} from "react-device-detect";

export class ArtworkGuidelineModel {
    private readonly _artworkGuidelineType: ArtworkGuidelineType;
    private readonly _artworkGuidelineTypeId: number | undefined;
    private readonly _isDesignerProduct: boolean;
    private readonly _productId: number | undefined;

    constructor(public readonly artworkGuidelineType: ArtworkGuidelineType, public readonly artworkGuidelineTypeId?: number, public readonly isDesignerProduct?: boolean, public readonly productId?: number) {
        this._artworkGuidelineType = artworkGuidelineType;
        this._artworkGuidelineTypeId = artworkGuidelineTypeId;
        this._isDesignerProduct = isDesignerProduct ?? false;
        this._productId = productId;
    }

    /**
     * @method id
     * @description Returns the id of the artwork guideline type. This is only available for custom artwork guideline types.
     * @returns {number | undefined}
     */
    public get id(): number | undefined {
        return this._artworkGuidelineTypeId;
    }

    /**
     * @method type
     * @description Returns the artwork guideline type, defaulted to ArtworkGuidelineType.None, if not provided.
     * @returns {ArtworkGuidelineType}
     */
    public get type(): ArtworkGuidelineType {
        return this._artworkGuidelineType;
    }

    /**
     * @method isTextOnly
     * @description Returns true if the artwork guideline type is ArtworkGuidelineType.TextOnly.
     * @returns {boolean}
     */
    public get isTextOnly(): boolean {
        return this._artworkGuidelineType === ArtworkGuidelineType.TextOnly;
    }

    public get isArtworkProduct(): boolean {
        return this._artworkGuidelineType !== ArtworkGuidelineType.None;
    }

    /**
     * @method href
     * @description Returns the href for the artwork guideline type, if both the artwork guideline type id and product id are provided.\
     * @returns {string | undefined}
     */
    public get href(): string | undefined {
        return this._artworkGuidelineTypeId && this._productId ? `/ArtworkGuideline/${this._artworkGuidelineTypeId}/${this._productId}` : undefined;
    }

    /**
     * @method breakOutEarly
     * @description Returns true if the type is ArtworkGuidelineType.None or if the id is undefined,
     * unless the product is a designer product on a mobile device as the designer on mobile is not supported.
     * @returns {boolean}
     */
    public get breakOutEarly(): boolean {
        if (this._isDesignerProduct) return !isMobile;
        return this._artworkGuidelineType === ArtworkGuidelineType.None || this._artworkGuidelineTypeId === undefined;
    }
}